<template>
  <dashboard-layout :loading="initialLoading" loading-text="正在加载伴侣详情">
    <div class="detail-page">
      <div class="profile-card">
        <img :src="portrait || require('@/assert/主页人物.png')" alt="" class="portrait" />
        <div class="info">
          <div class="name-row">
            <h2>{{ cName }}</h2>
            <span class="tag">{{ roleCardName }}</span>
            <span class="online" :class="{ off: bindStatus !== 'bound' }">● {{ bindStatus === "bound" ? "已绑定微信" : "未绑定" }}</span>
          </div>
          <blockquote>「{{ cIntro }}」</blockquote>
          <div class="attrs">
            <span v-for="a in cAttrs" :key="a">{{ a }}</span>
          </div>
        </div>
        <div class="meters">
          <div v-for="m in meters" :key="m.label" class="meter">
            <label>{{ m.label }}</label>
            <el-progress type="circle" :percentage="m.val" :width="64" :color="m.color" :show-text="false" />
            <b>{{ m.val }}/100</b>
            <small>{{ m.status }}</small>
          </div>
        </div>
      </div>

      <div class="detail-actions">
        <el-button size="small" round icon="el-icon-edit" @click="activeTab = '编辑'">编辑基础信息</el-button>
        <el-button size="small" round icon="el-icon-chat-round" @click="wxVisible = true">微信绑定管理</el-button>
        <el-button size="small" round icon="el-icon-delete" class="danger" @click="confirmDelete">删除伴侣</el-button>
      </div>

      <div class="tabs">
        <span v-for="t in tabs" :key="t" class="tab" :class="{ on: activeTab === t }" @click="activeTab = t">{{ t }}</span>
      </div>

      <!-- 概览 -->
      <div v-show="activeTab === '概览'" class="grid two">
        <div class="col">
          <div class="card stats">
            <h3>互动统计</h3>
            <div class="stat-grid">
              <div><b>{{ stats.interaction_days }}</b><small>聊天天数</small></div>
              <div><b>{{ stats.total_messages }}</b><small>消息总数</small></div>
              <div><b>{{ stats.proactive_messages }}</b><small>主动消息</small></div>
              <div><b>{{ stats.average_reply_seconds }}s</b><small>平均回复</small></div>
            </div>
          </div>
          <div class="card">
            <h3>伴侣小记</h3>
            <p>{{ note || "暂无简介" }}</p>
            <div class="tags"><span v-for="t in noteTags" :key="t">{{ t }}</span></div>
          </div>
          <div class="card">
            <h3>今日状态</h3>
            <div class="state-list">
              <p><b>北京时间</b><span>{{ env.beijingTime || "—" }}</span></p>
              <p><b>所在地</b><span>{{ env.locationName }} · {{ env.localTime || "—" }}</span></p>
              <p><b>天气</b><span>{{ env.weatherText || "未知" }}</span></p>
              <p><b>状态</b><span>{{ env.todayStatus || "状态稳定" }}</span></p>
              <p><b>此刻位置</b><span>{{ env.currentLocation || "地点暂未展开" }}</span></p>
              <p><b>正在做</b><span>{{ env.currentActivity || "正在忙自己的事" }}</span></p>
            </div>
            <a class="more-link" @click="activeTab = '日程'">查看今日日程与着装 ></a>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <h3>关系趋势（近 7 天活跃度）</h3>
            <div v-if="trend.length" class="trend">
              <div v-for="p in trend" :key="p.label" class="bar-col">
                <div class="bar" :style="{ height: Math.max(4, p.value) + '%' }"></div>
                <span>{{ p.label }}</span>
              </div>
            </div>
            <p v-else class="empty-tip">暂无趋势数据</p>
          </div>
          <div class="card">
            <h3 class="card-head">最近记忆 <a @click="activeTab = '记忆'">查看全部</a></h3>
            <div v-for="m in memories.slice(0, 3)" :key="m.title" class="mem">
              <span class="icon">{{ m.icon }}</span>
              <div><b>{{ m.title }}</b><p>{{ m.desc }}</p></div>
              <em>{{ m.time }}</em>
            </div>
            <p v-if="!memories.length" class="empty-tip">暂无记忆</p>
          </div>
        </div>
      </div>

      <!-- 日程 -->
      <div v-show="activeTab === '日程'" class="grid two">
        <div class="card">
          <h3>今日日程</h3>
          <div v-if="scheduleTimeline.length" class="schedule-tl no-line">
            <div v-for="(item, i) in scheduleTimeline" :key="i" class="stl-item" :class="{ promise: item.promise }">
              <span class="stl-dot"></span>
              <div class="stl-body">
                <b v-if="item.time">{{ item.time }}</b>
                <span v-if="item.promise" class="promise-tag">★ 约定</span>
                <p>{{ item.text }}</p>
              </div>
            </div>
          </div>
          <p v-else class="empty-tip">今天的日程还没生成，聊两句就有了～</p>
        </div>
        <div class="col">
          <div class="card">
            <h3>今日着装</h3>
            <p v-if="env.weatherText" class="outfit-weather"><i class="el-icon-sunny"></i> {{ env.locationName }} · {{ env.weatherText }}</p>
            <p class="outfit-text">{{ env.outfit || "今天还没想好穿什么，等会儿出门前再定～" }}</p>
          </div>
          <div class="card">
            <h3>当前状态</h3>
            <div class="state-list">
              <p><b>状态</b><span>{{ env.todayStatus || "状态稳定" }}</span></p>
              <p><b>此刻位置</b><span>{{ env.currentLocation || "地点暂未展开" }}</span></p>
              <p><b>正在做</b><span>{{ env.currentActivity || "正在忙自己的事" }}</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- 记忆 -->
      <div v-show="activeTab === '记忆'" class="grid two">
        <div class="col">
          <div class="card">
            <h3>长期记忆（沉淀）</h3>
            <div v-for="(m, i) in longTermMemories" :key="'lt' + i" class="lt-mem">
              <span v-if="m.tag" class="lt-tag">{{ m.tag }}</span>
              <p>{{ m.text }}</p>
            </div>
            <p v-if="!longTermMemories.length" class="empty-tip">还没有沉淀的长期记忆，多聊聊就有啦～</p>
          </div>
          <div class="card">
            <h3>记忆片段</h3>
            <div v-for="(m, i) in memories" :key="i" class="mem">
              <span class="icon">{{ m.icon }}</span>
              <div><b>{{ m.title }}</b><p>{{ m.desc }}</p></div>
              <em>{{ m.time }}</em>
            </div>
            <p v-if="!memories.length" class="empty-tip">还没有记忆，多聊聊就有啦～</p>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <h3>短期记忆（最近对话）</h3>
            <div class="state-list">
              <p v-if="shortTerm.nickname"><b>对你的称呼</b><span>{{ shortTerm.nickname }}</span></p>
              <p v-if="shortTerm.last_chat_summary"><b>上次聊到</b><span>{{ shortTerm.last_chat_summary }}</span></p>
            </div>
            <div v-if="(shortTerm.preferences || []).length" class="st-block">
              <b>记住的偏好</b>
              <div class="tags"><span v-for="(p2, i) in shortTerm.preferences" :key="'p' + i">{{ p2 }}</span></div>
            </div>
            <div v-if="(shortTerm.important_topics || []).length" class="st-block">
              <b>重要话题</b>
              <div class="tags"><span v-for="(t2, i) in shortTerm.important_topics" :key="'t' + i">{{ t2 }}</span></div>
            </div>
            <p v-if="shortTermEmpty" class="empty-tip">短期记忆还是空的</p>
          </div>
          <div class="card">
            <h3>对话时间线</h3>
            <div v-for="(t, i) in timeline" :key="i" class="tl">
              <span class="tl-role" :class="t.role">{{ t.role === "user" ? "我" : cName }}</span>
              <p>{{ t.text }}</p>
              <em>{{ t.time }}</em>
            </div>
            <p v-if="!timeline.length" class="empty-tip">暂无对话记录</p>
          </div>
        </div>
      </div>

      <!-- 编辑 -->
      <div v-show="activeTab === '编辑'" class="grid two">
        <div class="card">
          <h3>基础信息</h3>
          <el-form label-position="top" class="detail-edit-form">
            <!-- 核心人设：最常改的身份与关系，放最前 -->
            <div class="form-grid">
              <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
              <el-form-item label="关系标签"><el-input v-model="form.relationshipLabel" placeholder="女朋友 / 知己…" /></el-form-item>
            </div>
            <el-form-item label="一句话介绍"><el-input v-model="form.intro" /></el-form-item>
            <div class="form-grid">
              <el-form-item label="性格标签"><el-input v-model="form.personalityLabel" placeholder="温柔黏人" /></el-form-item>
              <el-form-item label="性格特质（逗号分隔）"><el-input v-model="form.traitsText" placeholder="爱撒娇, 怕黑, 喜欢猫" /></el-form-item>
            </div>
            <el-form-item label="说话风格"><el-input type="textarea" :rows="2" v-model="form.speakingStyle" /></el-form-item>
            <el-form-item label="背景故事"><el-input type="textarea" :rows="3" v-model="form.backgroundStory" /></el-form-item>
            <el-form-item label="欢迎语"><el-input v-model="form.welcome" placeholder="新会话的第一句话" /></el-form-item>

            <h3 class="form-section">基础资料</h3>
            <div class="form-grid">
              <el-form-item label="年龄"><el-input-number v-model="form.age" :min="0" :max="120" style="width: 100%" /></el-form-item>
              <el-form-item label="性别"><el-input v-model="form.gender" placeholder="女" /></el-form-item>
              <el-form-item label="身份"><el-input v-model="form.identity" placeholder="大学生 / 设计师…" /></el-form-item>
              <el-form-item label="生日"><el-input v-model="form.birthday" placeholder="03-14" /></el-form-item>
              <el-form-item label="星座"><el-input v-model="form.zodiac" placeholder="双鱼座" /></el-form-item>
            </div>
            <el-form-item :label="`基础亲密度 —— 仅用于新会话起始值（当前会话 ${liveIntimacy}/100）`">
              <el-slider v-model="form.intimacy" :max="100" />
            </el-form-item>

            <h3 class="form-section">行为与模型</h3>
            <el-form-item label="互动风格（拟真 ↔ 情绪价值）">
              <el-select v-model="form.interactionMode" style="width: 100%">
                <el-option label="混合型（有真人质感，但终点让人安心）" value="hybrid" />
                <el-option label="情绪导向型（始终温暖在场，主打情绪价值）" value="emotional" />
                <el-option label="真人模拟型（有脾气有节奏，更像真人）" value="realistic" />
              </el-select>
            </el-form-item>
            <el-form-item label="角色卡">
              <el-select v-model="form.roleCard" style="width: 100%">
                <el-option v-for="rc in roleCards" :key="rc.id" :label="rc.name" :value="rc.id" />
              </el-select>
            </el-form-item>
            <div class="form-grid">
              <el-form-item label="历史消息条数"><el-input-number v-model="form.historyLimit" :min="4" :max="50" style="width: 100%" /></el-form-item>
              <el-form-item label="生图模式">
                <el-select v-model="form.imageMode" style="width: 100%">
                  <el-option label="优先图生图" value="edit_first" />
                  <el-option label="优先文生图" value="fast_first" />
                  <el-option label="仅图生图" value="edit" />
                  <el-option label="仅文生图" value="fast" />
                </el-select>
              </el-form-item>
            </div>
            <el-form-item label="提示词补充"><el-input type="textarea" :rows="4" v-model="form.prompt" /></el-form-item>
            <p class="rt-note">所在地、天气、今日状态/日程/着装、当前活动等会随聊天自动生成，不在这里手填。</p>

            <el-button type="primary" round :loading="saving" @click="saveBasic" class="save-basic-btn">保存修改</el-button>
          </el-form>
        </div>
        <div class="card">
          <h3>当前生效提示词</h3>
          <pre class="prompt-box">{{ promptText || "暂无" }}</pre>
        </div>
      </div>

      <!-- 图片 -->
      <div v-show="activeTab === '图片'" class="grid two">
        <div class="card">
          <h3 class="card-head">
            图库 ({{ gallery.length }})
            <el-upload action="#" :show-file-list="false" accept="image/*" :before-upload="(f) => onUpload(f, 'gallery')"><a>+ 上传</a></el-upload>
          </h3>
          <div class="asset-grid">
            <div v-for="g in gallery" :key="g.id" class="asset-cell">
              <el-image
                v-if="g.url"
                class="asset-preview"
                :src="g.url"
                fit="cover"
                :preview-src-list="galleryPreviewUrls"
                :initial-index="galleryPreviewUrls.indexOf(g.url)"
                :z-index="3000"
                :alt="g.note || '图库图片'"
                title="点击放大查看"
                tabindex="0"
                role="button"
                @keydown.space.prevent
                @keyup.enter="$event.currentTarget.click()"
                @keyup.space="$event.currentTarget.click()"
              >
                <div slot="error" class="asset-image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <i v-else class="el-icon-picture-outline"></i>
              <span v-if="g.url" class="preview-hint" aria-hidden="true"><i class="el-icon-zoom-in"></i> 放大查看</span>
              <i class="el-icon-delete del" @click="removeAsset(g, 'gallery')"></i>
            </div>
          </div>
          <p v-if="!gallery.length" class="empty-tip">暂无图片</p>
        </div>
        <div class="card">
          <h3 class="card-head">
            贴纸 ({{ stickers.length }})
            <el-upload action="#" :show-file-list="false" accept="image/*" :before-upload="(f) => onUpload(f, 'stickers')"><a>+ 上传</a></el-upload>
          </h3>
          <div class="asset-grid">
            <div v-for="s in stickers" :key="s.id" class="asset-cell">
              <img v-if="s.url" :src="s.url" alt="" />
              <i v-else class="el-icon-orange"></i>
              <i class="el-icon-delete del" @click="removeAsset(s, 'stickers')"></i>
            </div>
          </div>
          <p v-if="!stickers.length" class="empty-tip">暂无贴纸</p>
        </div>
      </div>

      <!-- 关系 -->
      <div v-show="activeTab === '关系'" class="grid two">
        <div class="col">
          <div class="card intimacy-editor">
            <h3>手动调整亲密度</h3>
            <div class="intimacy-editor__summary">
              <strong>{{ intimacyDraft }}</strong>
              <div>
                <b>{{ intimacyDraftStage }}</b>
                <small>{{ activeSessionName || "当前主会话" }}</small>
              </div>
            </div>
            <el-slider v-model="intimacyDraft" :min="0" :max="100" :step="1" />
            <div class="intimacy-editor__actions">
              <el-input-number v-model="intimacyDraft" :min="0" :max="100" :step="1" size="small" />
              <el-button
                type="primary"
                size="small"
                :loading="intimacySaving"
                :disabled="!activeSessionId || intimacyDraft === liveIntimacy"
                @click="saveIntimacy"
              >保存当前亲密度</el-button>
            </div>
            <p class="intimacy-editor__hint">保存后立即影响当前会话的关系阶段和回复尺度，不修改新会话的基础值。</p>
          </div>
          <div class="card">
            <h3>关系趋势（近 7 天活跃度）</h3>
            <div v-if="trend.length" class="trend">
              <div v-for="p in trend" :key="p.label" class="bar-col">
                <div class="bar" :style="{ height: Math.max(4, p.value) + '%' }"></div>
                <span>{{ p.label }}</span>
              </div>
            </div>
            <p v-else class="empty-tip">暂无趋势数据</p>
          </div>
          <div class="card">
            <h3>同步记录</h3>
            <div v-for="(l, i) in syncLogs" :key="i" class="log">
              <span class="log-src" :class="l.source">{{ l.source === "web" ? "网页" : "微信" }}</span>
              <p>{{ l.text }}</p>
              <em>{{ l.time }}</em>
            </div>
            <p v-if="!syncLogs.length" class="empty-tip">暂无同步记录</p>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <h3 class="card-head">微信绑定 <a @click="wxVisible = true">管理</a></h3>
            <div v-for="b in bindings" :key="b.wechatId" class="bind-item">
              <div><b>{{ b.nickname }}</b><small>{{ b.wechatId }} · {{ b.online ? "在线" : "离线" }}</small></div>
            </div>
            <p v-if="!bindings.length" class="empty-tip">未绑定微信号</p>
          </div>
          <div class="card">
            <h3 class="card-head">主动联系定时任务 <a @click="openTaskDialog">+ 新建</a></h3>
            <div v-for="t in tasks" :key="t.id" class="task">
              <div class="task-info">
                <b>{{ t.typeLabel }} <span v-if="t.auto" class="auto-tag">系统自动</span></b>
                <p>{{ t.content }} · {{ t.time }}</p>
              </div>
              <span v-if="t.status === 'planned'" class="task-status planned">今天待触发</span>
              <span v-else-if="t.status === 'completed'" class="task-status done">已发送</span>
              <span v-else-if="t.status === 'failed'" class="task-status failed">失败</span>
              <el-switch v-else v-model="t.enabled" disabled active-color="#c94225" />
              <i v-if="!t.auto && t.status === 'active'" class="el-icon-close" @click="cancelTask(t)"></i>
            </div>
            <p v-if="!tasks.length" class="empty-tip">暂无定时任务</p>
          </div>
          <div class="card">
            <h3>互动设置</h3>
            <div class="im-quick">
              <span>互动风格<small class="sync-hint">拟真 ↔ 情绪价值，切换即时生效，可随时 A/B 对比</small></span>
              <el-radio-group v-model="interactionModeQuick" size="small" @change="onToggleInteractionMode">
                <el-radio-button label="hybrid">混合</el-radio-button>
                <el-radio-button label="emotional">情绪导向</el-radio-button>
                <el-radio-button label="realistic">真人模拟</el-radio-button>
              </el-radio-group>
            </div>
            <div class="sync">
              <span>深度思考<small class="sync-hint">开=回复更走心但更慢，关=回复更快。默认开启</small></span>
              <el-switch v-model="deepThinking" active-color="#c94225" @change="onToggleDeepThinking" />
            </div>
            <div class="sync">
              <span>主动联系<small class="sync-hint">TA 会在你没消息时主动找你、追问、关心、起新话题</small></span>
              <el-switch v-model="proactiveOn" active-color="#c94225" @change="onToggleProactive" />
            </div>
            <div class="sync"><span>微信消息同步到网页</span><el-switch v-model="sync1" active-color="#c94225" @change="onToggleSyncToWeb" /></div>
            <div class="sync"><span>网页消息同步到微信</span><el-switch v-model="pushToWx" active-color="#c94225" @change="onTogglePush" /></div>
            <el-button size="small" round class="reset-btn" @click="confirmResetMemory">清空当前会话记忆</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 微信绑定管理 -->
    <el-dialog title="微信绑定管理" :visible.sync="wxVisible" width="460px" custom-class="yw-dialog">
      <p class="dialog-hint">该伴侣可绑定一个或多个微信号；同一微信号下用 <code>/su</code> 命令切换活跃伴侣。</p>
      <div v-for="b in bindings" :key="b.wechatId" class="bind-item">
        <div>
          <b>{{ b.nickname }}</b>
          <small>
            {{ b.wechatId }} · {{ b.online ? "在线" : "离线" }} ·
            {{ b.memoryShared ? "网页与微信记忆已共享" : "等待本人会话确认" }}
          </small>
        </div>
        <el-button size="mini" round class="danger" :loading="bindBusy" @click="removeBinding(b)">移除绑定</el-button>
      </div>
      <p v-if="!bindings.length" class="empty-tip" style="margin: 0 0 14px">该伴侣还未绑定任何微信号</p>
      <p v-else-if="!needsOwnerClaim" class="dialog-hint">绑定已完成，网页主会话与本人微信会话共用同一套记忆。</p>
      <div v-if="needsOwnerClaim" class="owner-claim">
        <el-button size="small" round :loading="claimBusy" @click="createOwnerPeerClaim">认领本人微信会话</el-button>
        <p v-if="ownerClaim.code" class="dialog-hint">
          当前微信授权没有返回稳定的本人标识。请在 10 分钟内用你本人的微信向该伴侣发送口令
          <b>{{ ownerClaim.code }}</b>。口令仅可使用一次；验证后两端将共享记忆。
        </p>
      </div>
      <div class="add-bind">
        <el-select v-model="addWxId" placeholder="选择已有微信号" size="small" style="flex: 1">
          <el-option v-for="a in availableAccounts" :key="a.wechatId" :label="a.nickname" :value="a.wechatId" />
        </el-select>
        <el-button size="small" round :loading="bindBusy" @click="addBinding">绑定</el-button>
        <el-button size="small" round type="primary" @click="$router.push('/wechat-accounts')">扫码新增</el-button>
      </div>
    </el-dialog>

    <!-- 新建定时任务 -->
    <el-dialog title="新建主动联系任务" :visible.sync="taskVisible" width="440px" custom-class="yw-dialog">
      <el-form label-position="top">
        <el-form-item label="任务类型">
          <el-select v-model="taskForm.type" style="width: 100%">
            <el-option label="每日问候" value="checkin" />
            <el-option label="提醒" value="reminder" />
            <el-option label="发图" value="image" />
            <el-option label="发语音" value="voice" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容"><el-input v-model="taskForm.content" placeholder="例如：每天早上道早安" /></el-form-item>
        <el-form-item label="执行时间"><el-input v-model="taskForm.time" placeholder="例如：每天 08:00" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button round @click="taskVisible = false">取消</el-button>
        <el-button type="primary" round @click="saveTask">创建</el-button>
      </span>
    </el-dialog>
  </dashboard-layout>
</template>

<script>
import { companionApi, roleCardApi, wechatApi } from "@/services/api";
import DashboardLayout from "@/components/DashboardLayout.vue";

const PUSH_KEY = "xyo_push_wx";

export default {
  name: "CompanionDetailView",
  components: { DashboardLayout },
  data() {
    return {
      companionId: this.$route.query.id || "",
      activeSessionId: "",
      portrait: "",
      cName: "伴侣",
      cIntro: "",
      cAttrs: [],
      roleCardName: "",
      presentation: {},
      bindStatus: "unbound",
      sync1: true,
      pushToWx: true,
      proactiveOn: true,
      interactionModeQuick: "hybrid",
      deepThinking: true,
      companionRaw: {},
      liveIntimacy: 0,
      intimacyDraft: 0,
      intimacySaving: false,
      activeSessionName: "",
      relationshipVersion: 1,
      activeTab: "概览",
      tabs: ["概览", "日程", "记忆", "编辑", "图片", "关系"],
      meters: [
        { label: "亲密度", val: 0, color: "#c94225", status: "" },
        { label: "健康度", val: 0, color: "#52c41a", status: "" },
        { label: "精力值", val: 0, color: "#faad14", status: "" },
      ],
      stats: { interaction_days: 0, total_messages: 0, proactive_messages: 0, average_reply_seconds: 0 },
      note: "",
      noteTags: [],
      memories: [],
      longTermMemories: [],
      shortTerm: {},
      timeline: [],
      trend: [],
      syncLogs: [],
      env: {
        locationName: "北京",
        beijingTime: "",
        localTime: "",
        weatherText: "",
        todayStatus: "",
        todaySchedule: [],
        outfit: "",
        currentLocation: "",
        currentActivity: "",
      },
      promptText: "",
      roleCards: [],
      tasks: [],
      gallery: [],
      stickers: [],
      saving: false,
      form: {
        name: "",
        intro: "",
        roleCard: "",
        prompt: "",
        welcome: "",
        historyLimit: 12,
        imageMode: "edit_first",
        interactionMode: "hybrid",
        intimacy: 30,
        age: 19,
        gender: "",
        identity: "",
        relationshipLabel: "",
        birthday: "",
        zodiac: "",
        personalityLabel: "",
        speakingStyle: "",
        backgroundStory: "",
        traitsText: "",
        locationName: "北京",
        locationTimezone: "Asia/Shanghai",
        locationLatitude: "39.9042",
        locationLongitude: "116.4074",
      },
      wxVisible: false,
      bindings: [],
      accounts: [],
      addWxId: "",
      bindBusy: false,
      claimBusy: false,
      ownerClaim: {},
      taskVisible: false,
      taskForm: { type: "checkin", content: "", time: "" },
      initialLoading: true,
    };
  },
  computed: {
    galleryPreviewUrls() {
      return this.gallery.map((item) => item.url).filter(Boolean);
    },
    availableAccounts() {
      const bound = this.bindings.map((b) => b.wechatId);
      return this.accounts.filter((a) => !bound.includes(a.wechatId));
    },
    needsOwnerClaim() {
      return this.bindings.some((b) => !b.memoryShared);
    },
    scheduleTimeline() {
      return (this.env.todaySchedule || []).map((raw) => {
        let s = String(raw).trim();
        const promise = /^约定[:：]/.test(s);
        if (promise) s = s.replace(/^约定[:：]\s*/, "");
        const m = s.match(/^(\d{1,2}[:：]\d{2})\s*(.*)$/);
        return { time: m ? m[1].replace("：", ":") : "", text: m ? m[2] : s, promise };
      });
    },
    shortTermEmpty() {
      const s = this.shortTerm || {};
      return !s.nickname && !s.last_chat_summary && !(s.preferences || []).length && !(s.important_topics || []).length;
    },
    intimacyDraftStage() {
      const value = Number(this.intimacyDraft) || 0;
      if (value >= 80) return "深度羁绊";
      if (value >= 60) return "关系亲近";
      if (value >= 40) return "关系稳定";
      if (value >= 20) return "逐渐熟悉";
      return "初识";
    },
  },
  created() {
    if (this.companionId) {
      this.load();
      this.loadRoleCards();
      this.loadBindings();
    } else {
      this.initialLoading = false;
    }
  },
  methods: {
    async load() {
      try {
        const m = await companionApi.management(this.companionId);
        const c = m.companion;
        const p = c.presentation || {};
        this.presentation = p;
        const d = m.detail || {};
        this.cName = c.name;
        this.cIntro = c.description || p.background_story || "";
        this.roleCardName = c.role_card_name || "伴侣";
        this.bindStatus = c.binding_status;
        this.sync1 = p.sync_to_web !== false;
        this.pushToWx = this.loadPushPref(this.companionId, p.web_to_weixin !== false);
        this.proactiveOn = !!p.allow_proactive;
        this.interactionModeQuick = c.interaction_mode || "hybrid";
        this.deepThinking = c.deep_thinking !== false;
        this.companionRaw = c;
        const activeSession = m.active_session || null;
        this.activeSessionId = (activeSession && activeSession.session_id) || "";
        this.activeSessionName = (activeSession && activeSession.display_name) || "";
        this.relationshipVersion = Number((activeSession && activeSession.relationship_version) || 1);
        this.cAttrs = [p.age_label, p.birthday, p.zodiac, p.identity_label, p.personality_label].filter(Boolean);
        this.env = {
          locationName: p.location_name || "北京",
          beijingTime: p.beijing_time || "",
          localTime: p.local_time || "",
          weatherText: p.weather && p.weather.summary ? `${p.weather.summary} · ${p.weather.temperature || "—"}°C` : "",
          todayStatus: p.today_status || "",
          todaySchedule: p.today_schedule || [],
          outfit: p.outfit || "",
          currentLocation: p.current_location || "",
          currentActivity: p.current_activity || "",
        };
        const activeIntimacy = activeSession && activeSession.snapshot && activeSession.snapshot.state
          ? activeSession.snapshot.state.relationship_temperature
          : null;
        const fallbackIntimacy = p.intimacy !== null && p.intimacy !== undefined
          ? p.intimacy
          : (c.intimacy_base_level !== null && c.intimacy_base_level !== undefined ? c.intimacy_base_level : 0);
        this.liveIntimacy = activeIntimacy === null || activeIntimacy === undefined ? fallbackIntimacy : activeIntimacy;
        this.intimacyDraft = this.liveIntimacy;
        this.meters = [
          { label: "亲密度", val: this.liveIntimacy, color: "#c94225", status: "" },
          { label: "健康度", val: p.health || 0, color: "#52c41a", status: "" },
          { label: "精力值", val: p.energy || 0, color: "#faad14", status: "" },
        ];
        const s = d.overview_stats || {};
        this.stats = {
          interaction_days: s.interaction_days || 0,
          total_messages: s.total_messages || 0,
          proactive_messages: s.proactive_messages || 0,
          average_reply_seconds: s.average_reply_seconds || 0,
        };
        this.note = p.background_story || c.description || "";
        this.noteTags = [...(p.traits || []), ...(p.emotion_tags || []), ...(p.story_tags || [])].filter(Boolean).slice(0, 6);
        this.memories = (d.memories || []).map((x) => ({ icon: x.icon || "◉", title: x.title, desc: x.content, time: x.time }));
        this.longTermMemories = (d.long_term_memories || []).map((line) => {
          const mm = String(line).match(/^\[([^\]]+)\]\s*(.*)$/);
          return { tag: mm ? mm[1] : "", text: mm ? mm[2] : String(line) };
        });
        this.shortTerm = d.short_term_memory || {};
        this.timeline = d.timeline || [];
        this.trend = d.trend || [];
        this.syncLogs = d.sync_logs || [];
        const promptPreview = [];
        if (m.prompts && m.prompts.role_card_prompt) {
          promptPreview.push(m.prompts.role_card_prompt);
        }
        if (m.prompts && m.prompts.custom_prompt) {
          promptPreview.push(`【补充设定】\n${m.prompts.custom_prompt}`);
        }
        this.promptText = promptPreview.filter(Boolean).join("\n\n");
        this.tasks = (m.scheduled_tasks || []).map((t) => ({
          id: t.id,
          type: t.task_type,
          typeLabel: t.auto
            ? (t.title || "自动联系").replace(/^系统自动[:：]\s*/, "")
            : { reminder: "提醒", checkin: "每日问候", image: "发图", voice: "发语音" }[t.task_type] || t.task_type,
          content: t.auto ? t.prompt : t.title || t.prompt,
          time: (t.run_at || "").replace("T", " ").slice(5, 16),
          status: t.status,
          auto: !!t.auto,
          enabled: t.status === "active",
        }));
        this.gallery = (m.gallery_images || []).map((g) => ({ id: g.id, note: g.note || g.name, url: g.public_url }));
        this.stickers = (m.stickers || []).map((s2) => ({ id: s2.id, note: s2.note || s2.name, url: s2.public_url }));
        this.form = {
          name: c.name,
          intro: c.description,
          roleCard: c.role_card_id,
          prompt: c.custom_prompt,
          welcome: c.welcome_message || "",
          historyLimit: c.message_history_limit || 12,
          imageMode: c.image_generation_mode || "edit_first",
          interactionMode: c.interaction_mode || "hybrid",
          intimacy: c.intimacy_base_level !== null && c.intimacy_base_level !== undefined ? c.intimacy_base_level : 30,
          age: parseInt(p.age_label) || 19,
          gender: p.gender || "",
          identity: p.identity_label || "",
          relationshipLabel: p.relationship_label || "",
          birthday: p.birthday || "",
          zodiac: p.zodiac || "",
          personalityLabel: p.personality_label || "",
          speakingStyle: p.speaking_style || "",
          backgroundStory: p.background_story || "",
          traitsText: (p.traits || []).join(", "),
          locationName: p.location_name || "北京",
          locationTimezone: p.location_timezone || "Asia/Shanghai",
          locationLatitude: p.location_latitude || "39.9042",
          locationLongitude: p.location_longitude || "116.4074",
        };
        const roleCards = await roleCardApi.list().catch(() => []);
        const card = (roleCards || []).find((rc) => rc.id === c.role_card_id);
        this.portrait = (card && card.reference_image_url) || "";
      } catch (e) {
        this.$message.warning("加载伴侣详情失败");
      } finally {
        this.initialLoading = false;
      }
    },
    async loadRoleCards() {
      try {
        this.roleCards = (await roleCardApi.list()) || [];
      } catch (e) {
        this.roleCards = [];
      }
    },
    async loadBindings() {
      try {
        const [accounts, bindings] = await Promise.all([
          wechatApi.list().catch(() => []),
          companionApi.wechatBindings(this.companionId).catch(() => []),
        ]);
        this.accounts = (accounts || []).map((a) => ({
          wechatId: a.wechat_account_id,
          nickname: a.nickname || a.wechat_account_id,
          online: a.gateway_status === "online",
        }));
        this.bindings = (bindings || []).map((b) => ({
          wechatId: b.wechat_account_id,
          nickname: (b.account && b.account.nickname) || b.wechat_account_id,
          online: !!(b.account && b.account.gateway_status === "online"),
          memoryShared: !!b.memory_shared,
          ownerPeerMethod: b.owner_peer_method || "",
        }));
      } catch (e) {
        this.accounts = [];
        this.bindings = [];
      }
    },
    async saveBasic() {
      if (!this.form.name) {
        this.$message.warning("请填写名称");
        return;
      }
      if (!this.form.roleCard) {
        this.$message.warning("请选择角色卡");
        return;
      }
      this.saving = true;
      try {
        await companionApi.update(this.companionId, this.companionUpdatePayload());
        await companionApi.updatePresentation(this.companionId, this.buildPresentationPayload());
        this.$message.success("已保存");
        this.load();
      } catch (e) {
        this.$message.error(e.message || "保存失败");
      } finally {
        this.saving = false;
      }
    },
    async saveIntimacy() {
      if (!this.activeSessionId) {
        this.$message.warning("当前还没有可调整的会话");
        return;
      }
      const value = Math.max(0, Math.min(100, Math.round(Number(this.intimacyDraft) || 0)));
      this.intimacySaving = true;
      try {
        const idempotencyKey =
          window.crypto && typeof window.crypto.randomUUID === "function"
            ? `manual:${window.crypto.randomUUID()}`
            : `manual:${Date.now()}:${Math.random().toString(16).slice(2)}`;
        const updated = await companionApi.updateIntimacy(this.companionId, this.activeSessionId, {
          mode: "set",
          value,
          expected_relationship_version: this.relationshipVersion,
          reason: "用户在伴侣管理页手动校准",
          idempotency_key: idempotencyKey,
        });
        this.liveIntimacy = Number(updated.intimacy);
        this.relationshipVersion = Number(updated.relationship_version || this.relationshipVersion + 1);
        this.intimacyDraft = this.liveIntimacy;
        this.meters = this.meters.map((item) => (
          item.label === "亲密度" ? { ...item, val: this.liveIntimacy } : item
        ));
        this.presentation.intimacy = this.liveIntimacy;
        this.$message.success(`当前亲密度已调整为 ${this.liveIntimacy}`);
      } catch (e) {
        this.intimacyDraft = this.liveIntimacy;
        await this.load();
        this.$message.error(e.message || "亲密度调整失败");
      } finally {
        this.intimacySaving = false;
      }
    },
    buildPresentationPayload(overrides = {}) {
      return {
        age: this.form.age || 19,
        gender: this.form.gender || "",
        identity: this.form.identity || "",
        relationship_label: this.form.relationshipLabel || "",
        school_year: this.presentation.school_year || "",
        major: this.presentation.major || "",
        birthday: this.form.birthday || "",
        zodiac: this.form.zodiac || "",
        personality_label: this.form.personalityLabel || "",
        speaking_style: this.form.speakingStyle || "",
        values_text: this.presentation.values_text || "",
        background_story: this.form.backgroundStory || "",
        behavior_rules: this.presentation.behavior_rules || "",
        active_hours: this.presentation.active_hours || "10:00 - 22:00",
        location_name: this.presentation.location_name || "北京",
        location_timezone: this.presentation.location_timezone || "Asia/Shanghai",
        location_latitude: this.presentation.location_latitude || "39.9042",
        location_longitude: this.presentation.location_longitude || "116.4074",
        sync_to_web: this.sync1,
        web_to_weixin: this.presentation.web_to_weixin !== false,
        allow_proactive: this.proactiveOn,
        traits: (this.form.traitsText || "").split(/[,，]/).map((s) => s.trim()).filter(Boolean),
        emotion_tags: this.presentation.emotion_tags || [],
        story_tags: this.presentation.story_tags || [],
        ...overrides,
      };
    },
    async onToggleSyncToWeb(val) {
      try {
        await companionApi.updatePresentation(this.companionId, this.buildPresentationPayload({ sync_to_web: val }));
        this.$message.success(val ? "微信消息将同步到网页" : "已关闭微信消息同步");
      } catch (e) {
        this.sync1 = !val;
        this.$message.error(e.message || "设置失败");
      }
    },
    loadPushPref(companionId, defaultValue = true) {
      try {
        const map = JSON.parse(localStorage.getItem(PUSH_KEY) || "{}");
        if (Object.prototype.hasOwnProperty.call(map, companionId)) return map[companionId] !== false;
        const legacy = localStorage.getItem(`yw_push_wx_${companionId}`);
        if (legacy !== null) {
          const value = legacy === "1";
          this.savePushPref(companionId, value);
          return value;
        }
      } catch (e) {
        /* 使用后端默认值 */
      }
      return defaultValue !== false;
    },
    savePushPref(companionId, value) {
      try {
        const map = JSON.parse(localStorage.getItem(PUSH_KEY) || "{}");
        map[companionId] = !!value;
        localStorage.setItem(PUSH_KEY, JSON.stringify(map));
      } catch (e) {
        /* localStorage 不可用时仍以本轮状态和后端配置为准 */
      }
    },
    async onTogglePush(val) {
      this.savePushPref(this.companionId, val);
      try {
        await companionApi.updatePresentation(this.companionId, this.buildPresentationPayload({ web_to_weixin: val }));
        this.presentation.web_to_weixin = val;
        this.$message.success(val ? "网页消息将同步到微信" : "已关闭网页消息同步");
      } catch (e) {
        this.pushToWx = !val;
        this.savePushPref(this.companionId, !val);
        this.$message.error(e.message || "设置失败");
      }
    },
    async onToggleProactive(val) {
      try {
        await companionApi.updatePresentation(this.companionId, this.buildPresentationPayload({ allow_proactive: val }));
        this.$message.success(val ? "已开启主动联系，TA 会主动找你了" : "已关闭主动联系");
      } catch (e) {
        this.proactiveOn = !val;
        this.$message.error(e.message || "设置失败");
      }
    },
    companionUpdatePayload(overrides = {}) {
      // companionApi.update 走完整 CompanionPayload；relationship_mode/attraction_style 本页不编辑，
      // 从已加载的伴侣原样保留，避免被默认值冲掉。
      return {
        name: this.form.name,
        description: this.form.intro || "",
        role_card_id: this.form.roleCard,
        custom_prompt: this.form.prompt || "",
        welcome_message: this.form.welcome || "",
        message_history_limit: this.form.historyLimit,
        image_generation_mode: this.form.imageMode,
        intimacy_base_level: this.form.intimacy,
        relationship_mode: this.companionRaw.relationship_mode || "friend",
        attraction_style: this.companionRaw.attraction_style || "caring",
        interaction_mode: this.form.interactionMode,
        deep_thinking: this.deepThinking,
        ...overrides,
      };
    },
    async onToggleInteractionMode(val) {
      const prev = this.form.interactionMode;
      try {
        await companionApi.update(this.companionId, this.companionUpdatePayload({ interaction_mode: val }));
        this.form.interactionMode = val;
        const label = { hybrid: "混合型", emotional: "情绪导向型", realistic: "真人模拟型" }[val] || val;
        this.$message.success(`已切换为「${label}」`);
      } catch (e) {
        this.interactionModeQuick = prev;
        this.$message.error(e.message || "切换失败");
      }
    },
    async onToggleDeepThinking(val) {
      try {
        await companionApi.update(this.companionId, this.companionUpdatePayload({ deep_thinking: val }));
        this.$message.success(val ? "已开启深度思考（更走心但更慢）" : "已关闭深度思考（回复更快）");
      } catch (e) {
        this.deepThinking = !val;
        this.$message.error(e.message || "切换失败");
      }
    },
    confirmDelete() {
      this.$confirm("确定删除该伴侣吗？删除后聊天记录与记忆将一并清除，且不可恢复。", "删除伴侣", {
        type: "warning",
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            if (this.companionId) await companionApi.remove(this.companionId);
            this.$message.success("已删除");
            this.$router.push("/companions");
          } catch (e) {
            this.$message.error(e.message || "删除失败");
          }
        })
        .catch(() => {});
    },
    confirmResetMemory() {
      if (!this.activeSessionId) {
        this.$message.warning("当前没有可清空的会话");
        return;
      }
      this.$confirm("清空后将重置该会话的长期记忆并生成新的会话洞察，确定继续吗？", "清空会话记忆", {
        type: "warning",
        confirmButtonText: "确定清空",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            await companionApi.resetMemory(this.companionId, this.activeSessionId);
            this.$message.success("已清空当前会话记忆");
            this.load();
          } catch (e) {
            this.$message.error(e.message || "清空失败");
          }
        })
        .catch(() => {});
    },
    async removeBinding(b) {
      this.bindBusy = true;
      try {
        await companionApi.unbindWechat(this.companionId, b.wechatId);
        this.bindings = this.bindings.filter((x) => x.wechatId !== b.wechatId);
        this.$message.success("已移除绑定");
        this.load();
      } catch (e) {
        this.$message.error(e.message || "解绑失败");
      } finally {
        this.bindBusy = false;
      }
    },
    async addBinding() {
      if (!this.addWxId) {
        this.$message.warning("请选择微信号");
        return;
      }
      this.bindBusy = true;
      try {
        await companionApi.bindWechat(this.companionId, this.addWxId);
        const acc = this.accounts.find((a) => a.wechatId === this.addWxId);
        if (acc) this.bindings.push({ wechatId: acc.wechatId, nickname: acc.nickname, online: acc.online });
        this.addWxId = "";
        this.$message.success("已绑定");
        this.load();
      } catch (e) {
        this.$message.error(e.message || "绑定失败");
      } finally {
        this.bindBusy = false;
      }
    },
    async createOwnerPeerClaim() {
      this.claimBusy = true;
      try {
        this.ownerClaim = await companionApi.createOwnerPeerClaim(this.companionId);
        this.$message.success("认领口令已生成，请用本人微信发送");
      } catch (e) {
        this.$message.error(e.message || "生成认领口令失败");
      } finally {
        this.claimBusy = false;
      }
    },
    async onUpload(file, kind) {
      try {
        const created = await companionApi.uploadAsset(this.companionId, kind, file);
        const item = { id: created.id, note: created.note || created.name, url: created.public_url };
        if (kind === "gallery") this.gallery.push(item);
        else this.stickers.push(item);
        this.$message.success("上传成功");
      } catch (e) {
        this.$message.error(e.message || "上传失败");
      }
      return false;
    },
    async removeAsset(a, kind) {
      try {
        await companionApi.deleteAsset(this.companionId, a.id);
        if (kind === "gallery") this.gallery = this.gallery.filter((x) => x.id !== a.id);
        else this.stickers = this.stickers.filter((x) => x.id !== a.id);
        this.$message.success("已删除");
      } catch (e) {
        this.$message.error(e.message || "删除失败");
      }
    },
    openTaskDialog() {
      this.taskForm = { type: "checkin", content: "", time: "" };
      this.taskVisible = true;
    },
    async saveTask() {
      const labels = { checkin: "每日问候", reminder: "提醒", image: "发图", voice: "发语音" };
      if (!this.taskForm.content || !this.taskForm.time) {
        this.$message.warning("请填写任务内容和时间");
        return;
      }
      try {
        const created = await companionApi.createTask(this.companionId, {
          task_type: this.taskForm.type,
          title: this.taskForm.content,
          prompt: this.taskForm.content,
          run_at: this.taskForm.time,
        });
        this.tasks.push({
          id: created.id,
          type: created.task_type,
          typeLabel: labels[created.task_type] || created.task_type,
          content: created.title || created.prompt,
          time: created.run_at,
          enabled: created.status === "active",
        });
        this.taskVisible = false;
        this.$message.success("已创建任务");
      } catch (e) {
        this.$message.error(e.message || "创建失败");
      }
    },
    cancelTask(t) {
      this.$confirm(`取消任务「${t.typeLabel}」？`, "取消任务", { type: "warning" })
        .then(async () => {
          try {
            await companionApi.cancelTask(this.companionId, t.id);
            this.tasks = this.tasks.filter((x) => x.id !== t.id);
            this.$message.success("已取消");
          } catch (e) {
            this.$message.error(e.message || "取消失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.detail-page {
  .profile-card {
    display: flex;
    gap: 24px;
    margin-bottom: 18px;
    padding: 28px;
    border-radius: 20px;
    background: linear-gradient(120deg, #fffbf5 0%, #fff 60%);
    box-shadow: 0 8px 24px rgba(23, 16, 20, 0.05);

    .portrait {
      width: 160px;
      height: 200px;
      flex-shrink: 0;
      border-radius: 16px;
      object-fit: cover;
      object-position: center 18%;
      background: linear-gradient(180deg, #f7e7da, #e5c3ad);
    }

    .info {
      flex: 1;

      .name-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;

        h2 {
          margin: 0;
          font-size: 24px;
        }

        .tag {
          padding: 2px 10px;
          border-radius: 10px;
          color: #c94225;
          font-size: 11px;
          background: #fff0e8;
        }

        .online {
          color: #52c41a;
          font-size: 12px;

          &.off {
            color: #bbb;
          }
        }
      }

      blockquote {
        margin: 0 0 14px;
        padding-left: 12px;
        border-left: 3px solid #d8d1e0;
        color: #b64d38;
        font-size: 14px;
      }

      .attrs {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        span {
          padding: 4px 12px;
          border-radius: 12px;
          color: #888;
          font-size: 12px;
          background: #fafafa;
        }
      }
    }

    .meters {
      display: flex;
      gap: 16px;

      .meter {
        text-align: center;

        label {
          display: block;
          margin-bottom: 8px;
          color: #999;
          font-size: 12px;
        }

        b {
          display: block;
          margin-top: 6px;
          font-size: 13px;
        }

        small {
          color: #bbb;
          font-size: 11px;
        }
      }
    }
  }

  .detail-actions {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;

    .danger {
      color: #ff6b6b;
      border-color: #ffd0d0;
    }
  }

  .tabs {
    display: flex;
    gap: 24px;
    margin-bottom: 18px;
    padding: 0 8px;
    border-bottom: 1px solid #e8e3ed;
    background: #fff;
    border-radius: 12px 12px 0 0;

    .tab {
      padding: 12px 4px;
      color: #999;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #c94225;
      }

      &.on {
        color: #c94225;
        font-weight: 600;
        box-shadow: inset 0 -2px 0 #c94225;
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    &.two {
      grid-template-columns: repeat(2, 1fr);
    }

    .card {
      margin-bottom: 16px;
      padding: 20px;
      border-radius: 16px;
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      transition: box-shadow 0.25s;

      &:hover {
        box-shadow: 0 10px 26px rgba(201, 66, 37, 0.12);
      }

      h3 {
        margin: 0 0 14px;
        font-size: 15px;
      }

      .state-list {
        display: grid;
        gap: 8px;

        p {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          margin: 0;
          color: #777;
          font-size: 12px;
          line-height: 1.5;

          b {
            flex-shrink: 0;
            color: #333;
            font-size: 12px;
          }

          span {
            text-align: right;
          }
        }
      }

      .schedule-tl {
        margin-top: 12px;
        padding-top: 10px;
        border-top: 1px dashed #e8e3ed;

        .stl-item {
          position: relative;
          display: flex;
          gap: 10px;
          padding: 0 0 12px 2px;

          &::before {
            content: "";
            position: absolute;
            left: 5px;
            top: 12px;
            bottom: 0;
            width: 1px;
            background: #e8e3ed;
          }

          &:last-child::before {
            display: none;
          }

          .stl-dot {
            position: relative;
            z-index: 1;
            width: 8px;
            height: 8px;
            margin-top: 4px;
            flex-shrink: 0;
            border-radius: 50%;
            background: #d8d1e0;
          }

          .stl-body {
            flex: 1;
            min-width: 0;

            b {
              margin-right: 6px;
              color: #c94225;
              font-size: 12px;
            }

            .promise-tag {
              margin-right: 6px;
              padding: 1px 6px;
              border-radius: 8px;
              color: #fff;
              font-size: 10px;
              background: linear-gradient(90deg, #ffb04d, #ff9800);
            }

            p {
              display: inline;
              margin: 0;
              color: #666;
              font-size: 12px;
              line-height: 1.6;
            }
          }

          &.promise .stl-dot {
            background: #ff9800;
            box-shadow: 0 0 0 3px #fff3e0;
          }
        }

        &.no-line {
          margin-top: 0;
          padding-top: 0;
          border-top: 0;
        }
      }

      .more-link {
        display: inline-block;
        margin-top: 12px;
        color: #c94225;
        font-size: 12px;
        cursor: pointer;
      }

      .outfit-weather {
        margin: 0 0 10px;
        color: #999;
        font-size: 12px;

        i {
          margin-right: 4px;
          color: #faad14;
        }
      }

      .outfit-text {
        margin: 0;
        padding: 12px 14px;
        border-radius: 12px;
        color: #555;
        font-size: 13px;
        line-height: 1.8;
        background: #fff8f0;
      }

      .lt-mem {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 10px;

        .lt-tag {
          flex-shrink: 0;
          margin-top: 1px;
          padding: 1px 8px;
          border-radius: 8px;
          color: #c94225;
          font-size: 11px;
          background: #fff0e8;
        }

        p {
          margin: 0;
          color: #666;
          font-size: 12px;
          line-height: 1.7;
        }
      }

      .st-block {
        margin-top: 12px;

        > b {
          display: block;
          margin-bottom: 8px;
          color: #333;
          font-size: 12px;
        }
      }

      .mem {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;

        .icon {
          margin-right: 10px;
        }

        b {
          display: block;
          font-size: 13px;
        }

        p {
          margin: 2px 0 0;
          color: #999;
          font-size: 12px;
        }

        em {
          margin-left: auto;
          color: #ccc;
          font-size: 11px;
          font-style: normal;
        }
      }

      .stat-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;

        div {
          padding: 14px;
          border-radius: 12px;
          text-align: center;
          background: #fafafa;

          b {
            display: block;
            font-size: 22px;
            color: #c94225;
          }

          small {
            color: #999;
            font-size: 11px;
          }
        }
      }

      .trend {
        display: flex;
        align-items: flex-end;
        gap: 8px;
        height: 160px;
        padding: 8px 4px 0;

        .bar-col {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;

          .bar {
            width: 60%;
            min-height: 4px;
            border-radius: 6px 6px 0 0;
            background: linear-gradient(180deg, #b64d38, #c94225);
            transition: height 0.3s;
          }

          span {
            margin-top: 6px;
            color: #bbb;
            font-size: 10px;
          }
        }
      }

      .tl {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 12px;

        .tl-role {
          flex-shrink: 0;
          padding: 2px 8px;
          border-radius: 8px;
          color: #c94225;
          font-size: 11px;
          background: #fff0e8;

          &.user {
            color: #888;
            background: #f0f0f0;
          }
        }

        p {
          flex: 1;
          margin: 0;
          color: #555;
          font-size: 13px;
          line-height: 1.5;
        }

        em {
          flex-shrink: 0;
          color: #ccc;
          font-size: 11px;
          font-style: normal;
        }
      }

      .log {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;

        .log-src {
          flex-shrink: 0;
          padding: 2px 8px;
          border-radius: 8px;
          color: #52c41a;
          font-size: 11px;
          background: #f0fbe9;

          &.web {
            color: #409eff;
            background: #ecf5ff;
          }
        }

        p {
          flex: 1;
          margin: 0;
          color: #666;
          font-size: 12px;
        }

        em {
          color: #ccc;
          font-size: 11px;
          font-style: normal;
        }
      }

      .prompt-box {
        max-height: 420px;
        margin: 0;
        padding: 14px;
        overflow: auto;
        border-radius: 12px;
        color: #555;
        font-size: 12px;
        line-height: 1.6;
        white-space: pre-wrap;
        word-break: break-word;
        background: #fafafa;
        font-family: inherit;
      }

      .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 12px;

        span {
          padding: 4px 12px;
          border-radius: 12px;
          color: #b64d38;
          font-size: 12px;
          background: #fff4ee;
        }
      }

      .chat-sum {
        display: flex;
        gap: 10px;

        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center 18%;
          background: #edcdbb;
        }

        p {
          margin: 0 0 4px;
          font-size: 13px;
        }

        em {
          color: #ccc;
          font-size: 11px;
          font-style: normal;
        }
      }

      .sync {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        font-size: 13px;
        color: #666;
      }

      .im-quick {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 14px;
        font-size: 13px;
        color: #666;
      }

      .card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          color: #c94225;
          font-size: 12px;
          font-weight: 400;
          cursor: pointer;
        }
      }

      .task {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        padding: 10px 12px;
        border-radius: 12px;
        background: #fafafa;

        .task-info {
          flex: 1;
          min-width: 0;

          b {
            font-size: 13px;
          }

          p {
            margin: 2px 0 0;
            color: #999;
            font-size: 12px;
          }
        }

        .el-icon-close {
          color: #ccc;
          cursor: pointer;

          &:hover {
            color: #ff6b6b;
          }
        }

        .auto-tag {
          margin-left: 4px;
          padding: 1px 6px;
          border-radius: 8px;
          color: #8a6dff;
          font-size: 10px;
          font-weight: 400;
          background: #f1edff;
        }

        .task-status {
          flex-shrink: 0;
          font-size: 11px;

          &.planned {
            color: #8a6dff;
          }

          &.done {
            color: #52c41a;
          }

          &.failed {
            color: #ff6b6b;
          }
        }
      }

      .empty-tip {
        margin: 0;
        color: #bbb;
        font-size: 13px;
      }

      .asset-row {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .asset-label {
          width: 64px;
          color: #999;
          font-size: 12px;
        }

        .thumbs {
          display: flex;
          gap: 8px;

          .thumb {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 10px;
            color: #7255e9;
            font-size: 18px;
            background: #fff4ee;

            &.sticker {
              color: #faad14;
              background: #fff8e6;
            }
          }
        }
      }

      .reset-btn {
        margin-top: 8px;
        color: #ff6b6b;
        border-color: #ffd0d0;
      }
    }
  }
}

.dialog-hint {
  margin: 0 0 16px;
  padding: 10px 12px;
  border-radius: 10px;
  color: #b64d38;
  font-size: 12px;
  line-height: 1.5;
  background: #fff7ef;

  code {
    padding: 0 5px;
    border-radius: 6px;
    background: #fff0e8;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}

.form-section {
  margin: 8px 0 14px;
  padding-top: 14px;
  border-top: 1px dashed #e8e3ed;
  color: #c94225;
  font-size: 13px;
}

.sync .sync-hint {
  display: block;
  margin-top: 2px;
  max-width: 260px;
  color: #b0b0b0;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.4;
}

.detail-edit-form {
  .rt-note {
    margin: 2px 0 16px;
    padding-top: 12px;
    border-top: 1px dashed #e8e3ed;
    color: #b0b0b0;
    font-size: 12px;
    line-height: 1.5;
  }

  .save-basic-btn {
    margin-top: 4px;
  }
}

.bind-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 12px;
  background: #fafafa;

  b {
    display: block;
    font-size: 14px;
  }

  small {
    color: #aaa;
    font-size: 12px;
  }

  .danger {
    color: #ff6b6b;
    border-color: #ffd0d0;
  }
}

.add-bind {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}

.asset-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  .asset-cell {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 88px;
    border-radius: 12px;
    overflow: hidden;
    font-size: 12px;
  }

  .asset-cell {
    color: #7255e9;
    background: #fff4ee;

    > .el-icon-picture-outline,
    > .el-icon-orange {
      font-size: 24px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .asset-preview {
      width: 100%;
      height: 100%;
      cursor: zoom-in;

      ::v-deep .el-image__inner {
        width: 100%;
        height: 100%;
        transition: transform 180ms ease;
      }
    }

    .asset-image-error {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #aaa;
      background: #f8f4f1;
    }

    .preview-hint {
      position: absolute;
      left: 7px;
      bottom: 7px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 7px;
      border-radius: 8px;
      color: #fff;
      font-size: 11px;
      line-height: 1;
      pointer-events: none;
      opacity: 0;
      background: rgba(47, 33, 26, 0.72);
      transform: translateY(3px);
      transition: opacity 160ms ease, transform 160ms ease;
    }

    &:hover,
    &:focus-within {
      .preview-hint {
        opacity: 1;
        transform: translateY(0);
      }

      .asset-preview ::v-deep .el-image__inner {
        transform: scale(1.035);
      }
    }

    .note {
      margin-top: 4px;
      color: #999;
    }

    .del {
      position: absolute;
      right: 6px;
      top: 6px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        color: #ff6b6b;
      }
    }
  }
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .asset-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .detail-page {
    .profile-card {
      flex-wrap: wrap;
      gap: 14px;
      padding: 16px;

      .portrait {
        width: 110px;
        height: 140px;
      }
    }

    .detail-actions {
      flex-wrap: wrap;
    }

    .tabs {
      gap: 14px;
      overflow-x: auto;

      .tab {
        flex-shrink: 0;
      }
    }

    .grid,
    .grid.two {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
}
</style>

<style scoped lang="scss">
/* Workbench treatment: continuous surfaces, restrained hierarchy, no decorative pink. */
.detail-page {
  min-width: 0;
  color: var(--xyo-ink);

  .profile-card {
    align-items: stretch;
    gap: 22px;
    margin: 6px 0 14px;
    padding: 22px;
    overflow: hidden;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);

    .portrait {
      width: 132px;
      height: 168px;
      border: 1px solid var(--xyo-line);
      border-radius: var(--xyo-radius-md);
      background: var(--xyo-surface-muted);
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-width: 0;

      .name-row {
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 12px;

        h2 {
          color: var(--xyo-ink-strong);
          font-size: clamp(23px, 2.2vw, 30px);
          letter-spacing: -0.035em;
        }

        .tag {
          padding: 3px 9px;
          border: 1px solid #d8d1e0;
          border-radius: 999px;
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

        .online {
          color: var(--xyo-success);

          &.off {
            color: var(--xyo-muted);
          }
        }
      }

      blockquote {
        max-width: 680px;
        margin-bottom: 16px;
        padding: 2px 0 2px 13px;
        border-left-color: var(--xyo-primary);
        color: var(--xyo-ink-soft);
        line-height: 1.65;
      }

      .attrs {
        gap: 7px;

        span {
          padding: 4px 9px;
          border: 1px solid var(--xyo-line);
          border-radius: 999px;
          color: var(--xyo-ink-soft);
          background: var(--xyo-surface-muted);
        }
      }
    }

    .meters {
      align-items: center;
      gap: 18px;
      padding-left: 22px;
      border-left: 1px solid var(--xyo-line);

      .meter {
        min-width: 68px;

        label,
        small {
          color: var(--xyo-muted);
        }

        b {
          color: var(--xyo-ink-strong);
          font-variant-numeric: tabular-nums;
        }
      }
    }
  }

  .detail-actions {
    align-items: center;
    margin-bottom: 14px;
    padding: 0 2px;

    .danger {
      border-color: #e0bbc3 !important;
      color: var(--xyo-danger) !important;
      background: var(--xyo-danger-soft) !important;
    }
  }

  .tabs {
    position: sticky;
    top: 0;
    z-index: 8;
    gap: 4px;
    margin-bottom: 16px;
    padding: 6px;
    overflow-x: auto;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-md);
    background: rgba(252, 251, 253, 0.94);
    box-shadow: 0 6px 18px rgba(34, 28, 48, 0.06);
    backdrop-filter: blur(10px);
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .tab {
      flex: 0 0 auto;
      padding: 8px 14px;
      border-radius: var(--xyo-radius-sm);
      color: var(--xyo-muted);
      font-size: 13px;
      font-weight: 600;
      box-shadow: none;
      transition: color 180ms ease, background-color 180ms ease;

      &:hover {
        color: var(--xyo-primary);
        background: var(--xyo-accent-pale);
      }

      &.on {
        color: #fff;
        background: var(--xyo-primary);
        box-shadow: none;
      }
    }
  }

  .grid,
  .grid.two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
    overflow: hidden;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);

    > .col,
    > .card {
      min-width: 0;
    }

    > .col + .col,
    > .card + .card {
      border-left: 1px solid var(--xyo-line);
    }

    .col .card + .card {
      border-top: 1px solid var(--xyo-line);
    }

    .card {
      margin: 0;
      padding: 22px clamp(18px, 2.3vw, 28px);
      border: 0;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
      transition: background-color 180ms ease;

      &:hover {
        background: #fff;
        box-shadow: none;
      }

      h3 {
        margin-bottom: 16px;
        color: var(--xyo-ink-strong);
        font-size: 15px;
        font-weight: 720;
        letter-spacing: -0.012em;
      }

      .card-head a,
      .more-link {
        color: var(--xyo-primary);
        font-weight: 600;
      }

      .state-list {
        gap: 0;

        p {
          align-items: flex-start;
          padding: 9px 0;
          border-bottom: 1px solid #e8e3ed;
          color: var(--xyo-ink-soft);

          &:last-child {
            border-bottom: 0;
          }

          b {
            color: var(--xyo-ink);
          }
        }
      }

      .schedule-tl {
        border-color: var(--xyo-line);

        .stl-item {
          &::before {
            background: var(--xyo-line);
          }

          .stl-dot {
            background: #cba88f;
          }

          .stl-body {
            b {
              color: var(--xyo-primary);
            }

            p {
              color: var(--xyo-ink-soft);
            }

            .promise-tag {
              color: #fff;
              background: var(--xyo-warning);
            }
          }

          &.promise .stl-dot {
            background: var(--xyo-warning);
            box-shadow: 0 0 0 3px var(--xyo-warning-soft);
          }
        }
      }

      .outfit-weather,
      .mem p,
      .mem em,
      .trend span,
      .task p,
      .empty-tip {
        color: var(--xyo-muted);
      }

      .outfit-weather i {
        color: var(--xyo-warning);
      }

      .outfit-text,
      .prompt-box,
      .task,
      .stat-grid div {
        border: 1px solid var(--xyo-line);
        color: var(--xyo-ink-soft);
        background: var(--xyo-surface-muted);
      }

      .outfit-text {
        border-radius: var(--xyo-radius-sm);
      }

      .lt-mem {
        padding: 10px 0;
        margin: 0;
        border-bottom: 1px solid #e8e3ed;

        &:last-child {
          border-bottom: 0;
        }

        .lt-tag {
          border: 1px solid #d8d1e0;
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

        p {
          color: var(--xyo-ink-soft);
        }
      }

      .st-block > b,
      .mem b {
        color: var(--xyo-ink);
      }

      .stat-grid {
        gap: 8px;

        div {
          padding: 13px;
          border-radius: var(--xyo-radius-sm);

          b {
            color: var(--xyo-primary);
            font-size: 21px;
            font-variant-numeric: tabular-nums;
          }

          small {
            color: var(--xyo-muted);
          }
        }
      }

      .trend .bar-col {
        .bar {
          background: var(--xyo-primary);
        }

        span {
          color: var(--xyo-muted);
        }
      }

      .tl {
        padding: 9px 0;
        margin: 0;
        border-bottom: 1px solid #e8e3ed;

        &:last-child {
          border-bottom: 0;
        }

        .tl-role {
          border: 1px solid #d8d1e0;
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);

          &.user {
            border-color: var(--xyo-line);
            color: var(--xyo-ink-soft);
            background: var(--xyo-surface-muted);
          }
        }

        p {
          color: var(--xyo-ink-soft);
        }

        em {
          color: var(--xyo-muted);
        }
      }

      .log {
        padding: 9px 0;
        margin: 0;
        border-bottom: 1px solid #e8e3ed;

        &:last-child {
          border-bottom: 0;
        }

        .log-src,
        .log-src.web {
          border: 1px solid #b9d0c1;
          color: var(--xyo-success);
          background: var(--xyo-success-soft);
        }

        p {
          color: var(--xyo-ink-soft);
        }

        em {
          color: var(--xyo-muted);
        }
      }

      .prompt-box {
        border-radius: var(--xyo-radius-sm);
        font-family: "SFMono-Regular", Consolas, monospace;
      }

      .tags span {
        border: 1px solid var(--xyo-line);
        color: var(--xyo-ink-soft);
        background: var(--xyo-surface-muted);
      }

      .sync,
      .im-quick {
        color: var(--xyo-ink-soft);
      }

      .sync {
        min-height: 44px;
        margin: 0;
        padding: 9px 0;
        border-bottom: 1px solid #e8e3ed;

        &:last-of-type {
          border-bottom: 0;
        }
      }

      .im-quick {
        margin-bottom: 0;
        padding-bottom: 14px;
        border-bottom: 1px solid #e8e3ed;
      }

      .sync-hint {
        color: var(--xyo-muted);
      }

      .task {
        border-radius: var(--xyo-radius-sm);

        .el-icon-close:hover,
        .task-status.failed {
          color: var(--xyo-danger);
        }

        .auto-tag,
        .task-status.planned {
          color: var(--xyo-warning);
          background: var(--xyo-warning-soft);
        }

        .task-status.done {
          color: var(--xyo-success);
        }
      }

      .reset-btn {
        border-color: #e0bbc3 !important;
        color: var(--xyo-danger) !important;
        background: var(--xyo-danger-soft) !important;
      }
    }
  }
}

.dialog-hint {
  border: 1px solid var(--xyo-line);
  color: var(--xyo-ink-soft);
  background: var(--xyo-accent-pale);

  code {
    color: var(--xyo-primary);
    background: var(--xyo-accent-soft);
  }
}

.form-grid {
  gap: 0 20px;
}

.form-section {
  border-color: var(--xyo-line);
  color: var(--xyo-primary);
}

.detail-edit-form {
  .rt-note {
    border-color: var(--xyo-line);
    color: var(--xyo-muted);
  }
}

.bind-item {
  border: 1px solid var(--xyo-line);
  color: var(--xyo-ink);
  background: var(--xyo-surface-muted);

  small {
    color: var(--xyo-muted);
  }

  .danger {
    border-color: #e0bbc3 !important;
    color: var(--xyo-danger) !important;
    background: var(--xyo-danger-soft) !important;
  }
}

.asset-grid {
  grid-template-columns: repeat(auto-fill, minmax(112px, 1fr));

  .asset-cell {
    height: 104px;
    border: 1px solid var(--xyo-line);
    color: var(--xyo-primary);
    background: var(--xyo-surface-muted);

    .note {
      color: var(--xyo-muted);
    }

    .del {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      color: #fff;
      background: rgba(47, 33, 26, 0.72);

      &:hover {
        color: #fff;
        background: var(--xyo-danger);
      }
    }
  }
}

.intimacy-editor {
  .intimacy-editor__summary {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 12px;

    > strong {
      min-width: 64px;
      color: var(--xyo-primary);
      font-size: 38px;
      line-height: 1;
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 3px;

      b {
        color: var(--xyo-ink);
        font-size: 14px;
      }

      small {
        color: var(--xyo-muted);
        font-size: 12px;
      }
    }
  }

  .intimacy-editor__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 6px;

    .el-input-number {
      width: 128px;
    }
  }

  .intimacy-editor__hint {
    margin: 12px 0 0;
    color: var(--xyo-muted);
    font-size: 12px;
    line-height: 1.6;
  }
}

@media (max-width: 1080px) {
  .detail-page .profile-card {
    .meters {
      gap: 10px;
      padding-left: 16px;
    }
  }
}

@media (max-width: 900px) {
  .detail-page {
    .profile-card {
      flex-wrap: wrap;

      .info {
        min-width: calc(100% - 160px);
      }

      .meters {
        justify-content: space-around;
        width: 100%;
        padding: 16px 0 0;
        border-top: 1px solid var(--xyo-line);
        border-left: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .detail-page {
    .profile-card {
      display: grid;
      grid-template-columns: 92px minmax(0, 1fr);
      gap: 14px;
      padding: 14px;

      .portrait {
        width: 92px;
        height: 122px;
      }

      .info {
        min-width: 0;

        .name-row {
          gap: 6px;
          margin-bottom: 8px;

          h2 {
            width: 100%;
            font-size: 22px;
          }
        }

        blockquote {
          margin-bottom: 10px;
          font-size: 12px;
        }

        .attrs {
          max-height: none;
          overflow: visible;
        }
      }

      .meters {
        grid-column: 1 / -1;
        padding-top: 14px;

        .meter {
          min-width: 0;

          ::v-deep .el-progress-circle {
            width: 54px !important;
            height: 54px !important;
          }
        }
      }
    }

    .detail-actions {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));

      .el-button {
        width: 100%;
        margin: 0;
      }

      .danger {
        grid-column: 1 / -1;
      }
    }

    .tabs {
      margin-right: -2px;
      margin-left: -2px;

      .tab {
        padding: 8px 12px;
      }
    }

    .grid,
    .grid.two {
      display: block;
      border-radius: var(--xyo-radius-md);

      > .col + .col,
      > .card + .card,
      .col + .col {
        border-top: 1px solid var(--xyo-line);
        border-left: 0;
      }

      .card {
        padding: 20px 16px;

        .state-list p {
          display: grid;
          grid-template-columns: minmax(72px, 0.35fr) minmax(0, 1fr);

          span {
            min-width: 0;
            overflow-wrap: anywhere;
          }
        }

        .tl,
        .log,
        .task {
          align-items: flex-start;
          flex-wrap: wrap;
        }

        .tl p,
        .log p,
        .task .task-info {
          min-width: 0;
          overflow-wrap: anywhere;
        }

        .trend {
          height: 132px;
        }
      }
    }
  }

  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .add-bind {
    align-items: stretch;
    flex-direction: column;

    .el-button {
      width: 100%;
      margin: 0;
    }
  }

  .bind-item {
    align-items: flex-start;
    gap: 10px;
  }

  .asset-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .intimacy-editor .intimacy-editor__actions {
    align-items: stretch;
    flex-direction: column;

    .el-input-number,
    .el-button {
      width: 100%;
      margin: 0;
    }
  }
}

</style>
